import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Element from 'element-ui';
import axios from 'axios';
import VueAxios from 'vue-axios';
import '../src/assets/style/reset.css';
import 'element-ui/lib/theme-chalk/index.css';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import echarts from 'echarts';
import china from 'echarts/map/json/china.json'
echarts.registerMap('china', china)
import scroll from 'vue-seamless-scroll';
import 'swiper/dist/css/swiper.css';//引入样式

Vue.prototype.$echarts = echarts

Vue.use(VueAwesomeSwiper)
// Vue.use(VueAxios, axios)
Vue.prototype.$http = axios


Vue.prototype.$bus = new Vue();



Vue.use(Element, {
  // i18n: (key, value) => i18n.t(key, value)
});
Vue.use(scroll)


import 'lib-flexible'

Vue.config.productionTip = false

//用于router跳转报错


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
